var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 17 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M2.48438 11.0781C2.48438 9.42813 3.15438 7.92813 4.24438 6.83813L2.82438 5.41813C1.38438 6.86812 0.484375 8.86812 0.484375 11.0781C0.484375 15.1581 3.53437 18.5181 7.48438 19.0081V16.9881C4.65438 16.5081 2.48438 14.0481 2.48438 11.0781ZM16.4844 11.0781C16.4844 6.65812 12.9044 3.07812 8.48438 3.07812C8.42438 3.07812 8.36437 3.08813 8.30437 3.08813L9.39437 1.99813L7.98438 0.578125L4.48438 4.07812L7.98438 7.57812L9.39437 6.16813L8.31437 5.08813C8.37437 5.08813 8.43437 5.07812 8.48438 5.07812C11.7944 5.07812 14.4844 7.76813 14.4844 11.0781C14.4844 14.0481 12.3144 16.5081 9.48438 16.9881V19.0081C13.4344 18.5181 16.4844 15.1581 16.4844 11.0781Z",
          fill: "#85868B",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }